import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  const getRankColor = (rank: number) => {
    if (rank === 1) return 'bg-accent-500 text-background-50';
    if (rank === 2) return 'bg-secondary-400 text-background-50';
    if (rank === 3) return 'bg-primary-400 text-background-50';
    return 'bg-background-200 text-foreground-600';
  };

  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-extrabold text-foreground-900">热门排行</h2>
          <p className="text-sm text-foreground-600 mt-2">91视频当前最受欢迎的内容榜单，看看大家都在看什么</p>
        </div>

        <div className="space-y-3">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-100 rounded-xl p-4 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-extrabold flex-shrink-0 ${getRankColor(item.rank)}`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 truncate">{item.title}</h3>
                  <span className="px-1.5 py-0.5 rounded text-xs font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap flex-shrink-0">
                    {item.type}
                  </span>
                </div>
                <p className="text-xs text-foreground-600 truncate">{item.desc}</p>
              </div>
              <div className="flex items-center gap-1 flex-shrink-0">
                <i className="ri-fire-line text-accent-500 text-sm"></i>
                <span className="text-sm font-bold text-accent-500">{item.hot}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}